export default __webpack_public_path__ + "static/Medical-3a5bad3cd42336ca6d4116bee0df45b4.png";